module.exports = __webpack_public_path__ + "img/icon_validate_square.af229aa8.svg";